import { authedFetch, UnauthorizedError } from '@apis/auth';

/**
 * Profession entry surfaced by the BFF `/api/sites/:siteId/professions` route.
 * Mirrors the backend `AnalyticsProfession` shape — `id` is the upstream
 * Mongo `_id`, `tradeId` drives the per-trade pictogram fetched via the
 * storage proxy, and `contractor` / `specialty` populate the chip label
 * and the right-hand contractor column.
 */
export interface ISiteProfession {
  id: string;
  tradeId: string;
  tradeGroup: string | null;
  backgroundColor: string | null;
  contractor: string | null;
  specialty: string | null;
}

async function handle(res: Response): Promise<never> {
  const body = await res.json().catch(() => null);
  if (res.status === 401) throw new UnauthorizedError();
  throw new Error(`request failed: ${res.status} ${body?.error?.message ?? ''}`);
}

/**
 * Live working-professions list for the site. Used by the Contractor
 * Analysis card on the analytics landing — proxies trusstor's
 * `getWorkingProfessions` through the d-orca BFF. Empty array when the
 * upstream returns nothing (no professions configured, or 404).
 */
export async function fetchSiteProfessions(
  siteId: string,
  signal?: AbortSignal,
): Promise<ISiteProfession[]> {
  const res = await authedFetch(
    `/api/sites/${encodeURIComponent(siteId)}/analytics/professions`,
    { signal },
  );
  if (!res.ok) return handle(res);
  return (await res.json()) as ISiteProfession[];
}
